import Quality from './Quality';

export default Quality;
